import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  selectedServices,
  setSelectedPremiumServicesToStore,
} from "./../../../actions/action";
import CONSTANTS from "../../../constants";
import * as moment from "moment";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import { priceFormat } from "../../../helpers/functions";
import chevronExpandDetails from "../../../images/AC/ac-chevron-down-small-blue.png";
import validateIcon from "../../../images/AC/ac-validate-small-blue.png";
import infoIcon from "../../../images/AC/ac-info-v2.png";
import infoIconClicked from "../../../images/AC/ac-info-v2-black.png";

const mapDispatchToProps = {
  selectedServices,
  setSelectedPremiumServicesToStore,
};

const mapStateToProps = (state) => state;

const OperationItemSummaryFlex = (props) => {
  const isMobile = window.isMobile() == "mobile"
  useEffect(() => {
    setShowDetails(isMobile)
  }, []);
  const [showDetails, setShowDetails] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [showObligatoryMessage, setShowObligatoryMessage] = useState(false);
  const [expiredDate, setExpiredDate] = useState(false);
  const happyDiscount = Number(props.store.booking.happy);

  const verifyRDVdateLimit = () => {
    var dateLimit = props.store.dateLimitModif;
    if (props.store.isEditMode) {
      var limit = moment(dateLimit).format("YYYY/MM/DD");
      var now = moment().format("YYYY/MM/DD");
      if (now < limit) {
        setExpiredDate(false);
      } else {
        setExpiredDate(true);
      }
    }
  };
  const calculateforfaitPrice = () => {
    let price = 0;
    !!props.forfait.forfaits &&
      Object.values(props.forfait.forfaits).forEach((forfait, fkey) => {
        !!Object.values(forfait.SubFunctionList).length &&
          forfait.SubFunctionList[0].ForfaitList.forEach(
            (forfaitItem, fikey) => {
              if (forfaitItem.isSelected) {
                price += forfaitItem.Items[0].Prix;
              }
              if (forfaitItem.isSelected && forfaitItem.Operations) {
                forfaitItem.Operations.forEach((operation, OpKey) => {
                  if (operation.isSelected) {
                    price += operation.Items[0].Prix;
                  }
                });
              }
            }
          );
      });
    setTotalPrice(price);
  };
  const removeServicePremium = (serviceid) => {
    const filtredServices = Object.values(
      props.store.selectedPremiumServices
    ).filter((item) => item.idServicePremium !== serviceid);
    props.setSelectedPremiumServicesToStore(filtredServices);
  };
  const removeThatForfait = (interventionID) => {
    const selectedServices = Object.assign({}, props.store.SelectedServices);
    const filtredServices = Object.values(selectedServices).filter(
      (item) => item.interventionId !== interventionID
    );
    props.selectedServices(filtredServices);
  };

  useEffect(() => {
    calculateforfaitPrice();
  }, [totalPrice]);

  useEffect(() => {
    verifyRDVdateLimit();
  }, []);

  return (
    <div className="prestationsItemContainer" tabIndex="0">
      <div className="prestationsItem">
        <div className="iconLabelContainer">
          {props.forfait.Image && props.forfait.Image.length > 0 && (
            <div
              style={{
                backgroundImage: `url(${props.forfait.Image})`,
                width: "32px",
                height: "32px",
              }}
            ></div>
          )}
          <div className="labelAndButtonDetailContainer">
            <div className="forfaitLabel">
              {props.forfait.interventionLabel}
            </div>

            {props.isForfait && !!totalPrice && !isMobile && (
              <div
                className="detailsExpandContainer"
                tabIndex="0"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    pushEventToGTM({
                      pageName: "summary",
                      eventAction: "Display::Details",
                      eventLabel: "summary_detail",
                    });
                    setShowDetails(!showDetails);
                  }
                }}
                onClick={() => {
                  pushEventToGTM({
                    pageName: "summary",
                    eventAction: "Display::Details",
                    eventLabel: "summary_detail",
                  });

                  setShowDetails(!showDetails);
                  
                }}
              >
                <div className="detailsExpand">
                  {CONSTANTS.LABELS.common_v2_detail}
                </div>
                <img
                  className={
                    showDetails ? "chevronExpand isOpen" : "chevronExpand"
                  }
                  src={chevronExpandDetails}
                />
              </div>
            )}

            {!totalPrice && (
              <div
                className="labelNoPrice"
                dangerouslySetInnerHTML={{
                  __html:
                    CONSTANTS.LABELS.summary_operation_operationlist_noprice,
                }}
              ></div>
            )}
          </div>
        </div>

        {props.isForfait && !!totalPrice && (
          <div className="priceContainer">
            <div className="forfaitPrice">
              {!!happyDiscount
                ? priceFormat(
                    totalPrice - (totalPrice * 0.01 * happyDiscount).toFixed(3)
                  )
                : priceFormat(totalPrice)}
              {` ${CONSTANTS.LABELS.needs_basket_label2}`}
            </div>
            {!!happyDiscount && (
              <div
                className="happyHourLabel"
                dangerouslySetInnerHTML={{
                  __html: CONSTANTS.LABELS.needs_basket_discount_applied,
                }}
              ></div>
            )}
          </div>
        )}
      </div>
      {props.isForfait && showDetails && (
        <div className="prestationsItemBody">
          {props.forfait.forfaits.map((forfait, fkey) => (
            <React.Fragment key={fkey}>
              {forfait.SubFunctionList &&
                forfait.SubFunctionList[0].ForfaitList.map(
                  (forfaitItem, fikey) => {
                    if (!forfait.isConstructeur) {
                      return (
                        forfaitItem.isSelected && (
                          <div key={fikey} className="itemRow">
                            <div className="itemLabelContainer">
                              <img src={validateIcon} />
                              <div tabIndex="0" className="itemLabel">
                                {forfaitItem.Libelle}
                              </div>
                            </div>

                            <div tabIndex="0" className="itemPrice">
                              {!!happyDiscount
                                ? priceFormat(
                                    forfaitItem.Items[0].Prix -
                                      (
                                        forfaitItem.Items[0].Prix *
                                        0.01 *
                                        happyDiscount
                                      ).toFixed(2)
                                  )
                                : priceFormat(forfaitItem.Items[0].Prix)}
                              {` ${CONSTANTS.LABELS.needs_basket_label2}`}
                            </div>
                          </div>
                        )
                      );
                    } else {
                      return (
                        forfaitItem.isSelected && (
                          <React.Fragment key={fikey}>
                            <div className="itemRow">
                              <div className="itemLabelContainer">
                                <img src={validateIcon} />
                                <div tabIndex="0" className="itemLabel">
                                  {forfaitItem.Libelle}
                                </div>
                              </div>

                              <div tabIndex="0" className="itemPrice">
                                {!!happyDiscount
                                  ? priceFormat(
                                      forfaitItem.Items[0].Prix -
                                        (
                                          forfaitItem.Items[0].Prix *
                                          0.01 *
                                          happyDiscount
                                        ).toFixed(2)
                                    )
                                  : priceFormat(forfaitItem.Items[0].Prix)}
                                {` ${CONSTANTS.LABELS.needs_basket_label2}`}
                              </div>
                            </div>

                            <div className="complementaryOperationContainer">
                              <div
                                tabIndex="0"
                                className="complementaryOperationLabel"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    CONSTANTS.LABELS
                                      .summary_operation_complementary,
                                }}
                              ></div>
                              <div className="infoIconContainer">
                                <img
                                  src={
                                    showObligatoryMessage
                                      ? infoIconClicked
                                      : infoIcon
                                  }
                                  onClick={() =>
                                    setShowObligatoryMessage(
                                      !showObligatoryMessage
                                    )
                                  }
                                />
                                {showObligatoryMessage && (
                                  <div
                                    className="complementaryOperationsPopup"
                                    tabIndex="0"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        CONSTANTS.LABELS
                                          .needs_basket_maintenance_label8,
                                    }}
                                  ></div>
                                )}
                              </div>
                            </div>

                            {forfaitItem.Operations &&
                              forfaitItem.Operations.map((operation, OpKey) => {
                                return (
                                  operation.isSelected && (
                                    <div className="itemRow" key={OpKey}>
                                      <div className="itemLabelContainer">
                                        <img src={validateIcon} />
                                        <div tabIndex="0" className="itemLabel">
                                          {operation.Libelle}
                                        </div>
                                      </div>

                                      <div tabIndex="0" className="itemPrice">
                                        {!!happyDiscount
                                          ? priceFormat(
                                              operation.Items[0].Prix -
                                                (
                                                  operation.Items[0].Prix *
                                                  0.01 *
                                                  happyDiscount
                                                ).toFixed(2)
                                            )
                                          : priceFormat(
                                              operation.Items[0].Prix
                                            )}
                                        {` ${CONSTANTS.LABELS.needs_basket_label2}`}
                                      </div>
                                    </div>
                                  )
                                );
                              })}
                          </React.Fragment>
                        )
                      );
                    }
                  }
                )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OperationItemSummaryFlex);
